import { createElement } from 'react';

import { includedSlides } from './include.js';
import { Slide07Timeline } from './Slide07Timeline.js';
import { Slide08PeakHour } from './Slide08PeakHour.js';
import { Slide09Crowd } from './Slide09Crowd.js';
import { Slide10Skipper } from './Slide10Skipper.js';
import { Slide11Bookends } from './Slide11Bookends.js';
import { Slide12Outro } from './Slide12Outro.js';

import type { WrappedSlideSpec } from '../index.js';
import type { PartyWrapped } from '@mixwire/contracts';

export const LATE_SLIDES = (
  wrapped: PartyWrapped,
  onReplay: () => void,
): readonly WrappedSlideSpec[] =>
  includedSlides([
    {
      id: 'timeline',
      bg: 'night',
      ink: 'paper',
      durationMs: 9000,
      blobs: [
        { paint: 'red', x: '-62cqw', y: '-58cqh', scale: 0.4 },
        { paint: 'green', x: '0cqw', y: '-66cqh', scale: 0.4 },
        { paint: 'blue', x: '62cqw', y: '-58cqh', scale: 0.4 },
      ],
      content: createElement(Slide07Timeline, { wrapped }),
      when: wrapped.stints.length > 0,
    },
    {
      id: 'peak-hour',
      bg: 'plum',
      ink: 'paper',
      durationMs: 7500,
      blobs: [
        { paint: 'red', x: '44cqw', y: '-52cqh', scale: 1.1 },
        { paint: 'blue', x: '-52cqw', y: '62cqh', scale: 0.8 },
        { paint: 'green', x: '62cqw', y: '62cqh', scale: 0.3 },
      ],
      content: createElement(Slide08PeakHour, { wrapped }),
      when: wrapped.trackCount > 0,
    },
    {
      id: 'crowd',
      bg: 'paper',
      ink: 'night',
      durationMs: 8500,
      blobs: [
        { paint: 'blue', x: '-46cqw', y: '-52cqh', scale: 0.9 },
        { paint: 'red', x: '52cqw', y: '58cqh', scale: 0.8 },
        { paint: 'green', x: '56cqw', y: '-22cqh', scale: 0.25 },
      ],
      content: createElement(Slide09Crowd, { wrapped }),
      when: wrapped.tokenCount > 0 || wrapped.crowd.wants > 0,
    },
    {
      id: 'skipper',
      bg: 'blue',
      ink: 'night',
      durationMs: 7500,
      blobs: [
        { paint: 'paper', x: '-52cqw', y: '-46cqh', scale: 0.55 },
        { paint: 'night', x: '52cqw', y: '54cqh', scale: 1 },
        { paint: 'red', x: '56cqw', y: '-56cqh', scale: 0.3 },
      ],
      content: createElement(Slide10Skipper, { wrapped }),
      when: wrapped.trackCount > 0,
    },
    {
      id: 'bookends',
      bg: 'night',
      ink: 'paper',
      durationMs: 7500,
      blobs: [
        { paint: 'red', x: '-62cqw', y: '-46cqh', scale: 0.7 },
        { paint: 'blue', x: '62cqw', y: '52cqh', scale: 0.7 },
        { paint: 'green', x: '0cqw', y: '4cqh', scale: 0.18 },
      ],
      content: createElement(Slide11Bookends, { wrapped }),
      when: wrapped.opener !== null || wrapped.closer !== null,
    },
    {
      id: 'outro',
      bg: 'plum',
      ink: 'paper',
      durationMs: 12_000,
      blobs: [
        { paint: 'red', x: '-38cqw', y: '-46cqh', scale: 0.8 },
        { paint: 'green', x: '42cqw', y: '-30cqh', scale: 0.7 },
        { paint: 'blue', x: '0cqw', y: '52cqh', scale: 1.1 },
      ],
      content: createElement(Slide12Outro, { wrapped, onReplay }),
      when: true,
    },
  ]);
